import { useState } from 'react';
import { Cell } from 'react-table';
import protectedApi from '../../utils/API/ProtectectedApi';
import { Product } from '../../utils/responses/products';

export default function BooleanEdit({
  cell,
  field,
  updateData,
}: {
  cell: Cell<Product>;
  field: string;
  updateData: (rowIndex: number, columnId: string, value: any) => void;
}) {
  const [isLoading, setIsLoading] = useState(false);

  async function editProduct(state: boolean) {
    setIsLoading(true);
    try {
      const res = await protectedApi.patchProduct(cell.row.original.slug, {
        [field]: state,
      });
      updateData(cell.row.index, cell.column.id, state);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  }

  return (
    <div className='dropdown'>
      <button
        className='btn btn-light btn-sm dropdown-toggle tableDropDown'
        aria-expanded='false'
        data-bs-toggle='dropdown'
        type='button'>
        {isLoading ? (
          <span
            className='spinner-border spinner-border-sm'
            role='status'></span>
        ) : cell.value ? (
          'Yes'
        ) : (
          'No'
        )}
        &nbsp;
      </button>
      <div className='dropdown-menu tableDropDown'>
        <a
          className='dropdown-item'
          onClick={() => {
            if (!cell.value) editProduct(true);
          }}>
          Yes
        </a>
        <a
          className='dropdown-item'
          href='#'
          onClick={() => {
            if (cell.value) editProduct(false);
          }}>
          No
        </a>
      </div>
    </div>
  );
}
